import React from "react";
import Skeleton from "react-loading-skeleton";
import styled from "styled-components";

interface Props {
  items?: number;
  withVerticalLayout?: boolean;
}

export const DonutChartLoader: React.FC<Props> = ({
  items = 3,
  withVerticalLayout = true,
}) => {
  return (
    <Container
      style={{
        flexDirection: withVerticalLayout ? "column" : "row",
        gap: 45,
      }}
    >
      <PieChartSkeleton height={180} width={180} />
      <Legends>
        {Array.from({ length: items }, (_, i) => i).map((idx) => (
          <Skeleton
            key={`donut-chart-loader-${idx}`}
            height={25}
            width={withVerticalLayout ? 280 : 200}
          />
        ))}
      </Legends>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const PieChartSkeleton = styled(Skeleton)`
  border-radius: 50%;
`;

const Legends = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
